import type { AircraftCatalog, ArrivalInquiry, PlacementAlgorithm } from './types'

/**
 * Order inquiries by the chosen algorithm.
 * - `arrival`: earliest arrival first (rough first-fill).
 * - `departure`: earliest departure first, then larger footprint first (bigger
 *   aircraft want spots nearer the exit) — the doc's `departure_key`.
 */
export function sortInquiries(
  inquiries: ArrivalInquiry[],
  algorithm: PlacementAlgorithm,
  catalog: AircraftCatalog
): ArrivalInquiry[] {
  const sorted = [...inquiries]
  if (algorithm === 'arrival') {
    sorted.sort((a, b) => a.arrival - b.arrival || a.scheduleId.localeCompare(b.scheduleId))
  } else {
    const span = (i: ArrivalInquiry) => catalog.get(i.typeCode)?.footprint.wingspan ?? 0
    sorted.sort(
      (a, b) =>
        a.departure - b.departure ||
        span(b) - span(a) ||
        a.scheduleId.localeCompare(b.scheduleId)
    )
  }
  return sorted
}
